import { Component, OnInit } from '@angular/core';
import { MechanicsService } from '../services/mechanics.service';

declare const window:any

@Component({
    selector: 'modal-acceptance',
    templateUrl: './modal-acceptance.component.html',
    styleUrls: ['./modal-acceptance.component.styl'],
    standalone: false
})
export class ModalAcceptanceComponent implements OnInit {


	constructor(public ms: MechanicsService) { }

	ngOnInit() {

	}

	persistHide() {

		const l = `modalAcceptance persistHide()`

		this.ms.closeCurrentModal(l)
		localStorage.setItem("displayAcceptanceModal", "false")
	}

	rejected(){
		window.location = "https://www.wipo.int"
	}

}
